import { TeamExternalIntegration } from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const prometheusStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Prometheus',
  type: IntegrationType.Custom,
  authUrl: '',
  isPrivateNetworkIntegration: false,
  headers: [],
  url: '',
  sortIndex: 6
}
